var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"overflow":"hidden","overflow-x":"hidden","overflow-y":"hidden","height":"80%","width":"80%","position":"absolute"},attrs:{"src":_vm.iframeLink,"frameborder":"0","height":"150%","width":"150%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }